/*
 * Layout for a basic admin item, where we have a list of something (variables, statuses...)
 */

define([
  "marionette",
  "modules/shared/basicAdminList/template/basicAdminListTemplate.html",
], function (Marionette, BasicAdminListTemplate) {
  var BasicAdminListView = {};

  BasicAdminListView.basicAdminListLayout = Marionette.Layout.extend({
    template: BasicAdminListTemplate,
    regions: {
      list: "#adminList",
    },
    triggers: {
      "click #addItem": "add:item",
    },
  });

  return BasicAdminListView;
});
